import {
  TOKEN_ERROR,
  TOKEN_LOADING,
  TOKEN_SUCCESS,
  TOKEN_LOGOUT,
} from "../../ActionTypes";
import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";
import { parseBackendError, logError } from "../../../../global/utils/errorHandler";

export const wsGetToken = (token, nextStep) => (dispatch) => {
  dispatch({
    type: TOKEN_LOADING,
  });

  axiosLogin().then((respuesta) => {
    respuesta
      .get(`shared/Auth/legacy/authMail/${token}`)
      .then((res) => {
        let data = {
          ...res.data,
          origen: "tokenURL",
        };
        dispatch({
          type: TOKEN_SUCCESS,
          payload: data,
        });
        if (nextStep) {
          nextStep(true, res.data, token);
        }
      })
      .catch((err) => {
        // Parsear el error con nuestro handler robusto
        const parsedError = parseBackendError(err);
        
        // Log para debugging (solo en desarrollo)
        logError(err, "Login Token - authMail");

        // Preparar payload de error normalizado
        let error = {
          // RETROCOMPATIBILIDAD: detail siempre disponible como STRING
          detail: parsedError.userMessage,
          
          // Campo específico de este action
          origen: "portal",
          
          // Información adicional estructurada
          type: parsedError.type,
          validationErrors: parsedError.validationErrors,
          technicalDetails: parsedError.technicalDetails,
          title: parsedError.title,
          rawData: parsedError.rawData,
        };
        
        dispatch({
          type: TOKEN_ERROR,
          payload: error,
        });
        if (nextStep) nextStep(false, err);
      });
  });
};

export const loginTokenReset = () => (dispatch) => {
  dispatch({
    type: TOKEN_LOGOUT,
  });
};
